var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-keyboard",class:_vm.keyboardClass,staticStyle:{"font-family":"'Roboto', sans-serif !important"}})
}
var staticRenderFns = []

export { render, staticRenderFns }